module.exports = __webpack_public_path__ + "static/02-14b56aa77dbec9f302fc8b8962a76812.png";